import { Dependencies } from '../dependencies';
import { useTrialConditionFilter } from './useTrialConditionFilter';
import { useTrialCriteriaFilter } from './useTrialCriteriaFilter';
import { useTrialDateFilter } from './useTrialDateWithinFilter';
import { useTrialInterventionTypeFilter } from './useTrialInterventionTypeFilter';
import { useTrialPhaseFilter } from './useTrialPhaseFilter';
import { useTrialRadiusFilter } from './useTrialRadiusFilter';
import { useTrialSponsorFilter } from './useTrialSponsorFilter';
import { useTrialStatusFilter } from './useTrialStatusFilter';

export const trialFiltersDependencies = new Dependencies('trialFiltersDependencies', [
  useTrialConditionFilter,
  useTrialCriteriaFilter,
  useTrialDateFilter,
  useTrialInterventionTypeFilter,
  useTrialPhaseFilter,
  useTrialRadiusFilter,
  useTrialSponsorFilter,
  useTrialStatusFilter,
]);
export const clearTrialFilters = (...args) => {
  trialFiltersDependencies.clearDependencies(...args);
};
